var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyNotes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133 23C133 20.7909 131.209 19 129 19H37C34.7909 19 33 20.7909 33 23V139C33 141.209 34.7909 143 37 143H129C131.209 143 133 141.209 133 139V23Z",
    fill: "#F1F2F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130 20C130 17.7909 128.209 16 126 16H34C31.7909 16 30 17.7909 30 20V136C30 138.209 31.7909 140 34 140H126C128.209 140 130 138.209 130 136V20Z",
    fill: "#1E95F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38 16H34C31.7909 16 30 17.7909 30 20V136C30 138.209 31.7909 140 34 140H38V16Z",
    fill: "#077DDF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M130 33H133C134.105 33 135 33.8954 135 35V47C135 48.1046 134.105 49 133 49H130V33Z",
    fill: "#A5D5FC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M130 51H133C134.105 51 135 51.8954 135 53V65C135 66.1046 134.105 67 133 67H130V51Z",
    fill: "#00C4AC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9754 87.297L96.2752 81.6551C96.5125 81.2293 96.5125 80.7183 96.2752 80.3138L95.24 78.5254L89.7188 87.9783H91.8108C92.2853 87.9783 92.7382 87.7228 92.9754 87.297Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0223 87.2973L98.8203 85.9561C99.0575 85.5302 99.0575 85.0193 98.8203 84.6148L97.7851 82.8477L94.7656 87.9999H96.8577C97.3106 87.9786 97.7635 87.7232 98.0223 87.2973Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2168 87.9783L65.6956 78.5254L64.6604 80.3138C64.4231 80.7396 64.4231 81.2506 64.6604 81.6551L67.9386 87.297C68.1758 87.7228 68.6288 87.9783 69.1248 87.9783H71.2168Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2132 82.7637L62.1779 84.5308C61.9407 84.9566 61.9407 85.4676 62.1779 85.8721L62.9975 87.2985C63.2347 87.7243 63.6876 87.9798 64.1837 87.9798H66.2757L63.2132 82.7637Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3137 87.978H86.7666C87.2627 87.978 87.7156 87.7225 87.9528 87.2967L93.776 77.3328C94.0132 76.907 94.0132 76.396 93.776 75.9915L92.7408 74.2031L85.4941 86.5728L86.3137 87.978Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2422 87.9771L69.0171 75.6074H67.378L67.1623 76.0119C66.9251 76.4377 66.9251 76.9487 67.1623 77.3532L72.9855 87.2958C73.2228 87.7216 73.6757 87.9771 74.1717 87.9771H76.2422Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4156 84.74L91.2525 73.0516C91.4898 72.6258 91.4898 72.1148 91.2525 71.7103L90.2173 69.9219L82.9922 82.2916L84.4156 84.74Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1699 75.6074L78.0068 87.2958C78.244 87.7216 78.6969 87.9771 79.193 87.9771H81.285L74.0384 75.6074H71.1699Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0853 75.6074H76.1953L83.0322 87.2958C83.2694 87.7216 83.7223 87.9771 84.2184 87.9771H86.3104L79.0853 75.6074Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7684 60.2559H77.1688C76.6727 60.2559 76.2414 60.5113 75.9826 60.9372L74.9258 62.7043H85.9899L84.9546 60.9159C84.6958 60.5113 84.2429 60.2559 83.7684 60.2559Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2883 56H79.6492C79.1531 56 78.7218 56.2555 78.463 56.6813L77.4277 58.4697H83.5097L82.4745 56.6813C82.2373 56.2555 81.7843 56 81.2883 56Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6897 65.6231L87.4525 65.2399C87.2153 64.8141 86.7623 64.5586 86.2663 64.5586H74.6199C74.1238 64.5586 73.6925 64.8141 73.4337 65.2399L72.3984 67.0283H86.8702L87.6897 65.6231Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7956 68.8594H72.1218C71.6258 68.8594 71.1944 69.1149 70.9356 69.5407L69.9004 71.3291H84.3721L85.7956 68.8594Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4299 73.818L67.373 75.6064H81.8448L83.2898 73.1367H69.6161C69.12 73.158 68.6671 73.4135 68.4299 73.818Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6899 65.623L80.4648 77.9928L81.9099 80.4624L88.7467 68.774C88.984 68.3482 88.984 67.8372 88.7467 67.4327L87.6899 65.623Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyNotes);
export default __webpack_public_path__ + "static/media/empty-notes.57c3c686.svg";
export { ForwardRef as ReactComponent };